import { createFileRoute } from "@tanstack/react-router";
import { getPosts } from "@/lib/blog";
import { BlogIndex } from "@/components/BlogIndex";

export const Route = createFileRoute("/blog/")({
  loader: () => ({ posts: getPosts("en") }),
  head: () => ({
    meta: [
      { title: "Blog — AdKavi" },
      {
        name: "description",
        content:
          "Insights on AI advertising, campaign optimization, and digital marketing from the AdKavi team.",
      },
      { property: "og:title", content: "Blog — AdKavi" },
      {
        property: "og:description",
        content: "Insights on AI advertising and digital marketing from the AdKavi team.",
      },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_US" },
      { property: "og:url", content: "https://adkavi.ai/blog" },
    ],
    links: [
      { rel: "canonical", href: "https://adkavi.ai/blog" },
      { rel: "alternate", hreflang: "en", href: "https://adkavi.ai/blog" },
      { rel: "alternate", hreflang: "es", href: "https://adkavi.ai/es/blog" },
      { rel: "alternate", hreflang: "x-default", href: "https://adkavi.ai/blog" },
    ],
  }),
  component: EnBlogIndex,
});

function EnBlogIndex() {
  const { posts } = Route.useLoaderData();
  return <BlogIndex posts={posts} lang="en" />;
}
